import type { RouteType } from "ui-kit";
import { lazy } from "ui-kit";

import { paths } from "../paths/helpCenter";

export const routes: RouteType[] = [
  {
    path: paths.view,
    component: lazy(() => import("../pages/helpCenter/View")),
  },
];
